<!--
  ~ Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

@if (resourceService !== null) {
  <div class="resource-dropdown">
    <p-floatLabel variant="on">
      <bs-autocomplete
        bsFloatLabelCompat
        inputId="autocomplete"
        data-testid="resource-dropdown-autocomplete"
        [ngModel]="selectedResource"
        (ngModelChange)="selectedResource = $event"
        [items]="resources()"
        [loading]="bsLoading()"
        [dropdown]="!readonly"
        [requireSelection]="true"
        [disabled]="disabled || readonly"
        [minLength]="0"
        [displayWith]="getOptionLabel"
        [compareWith]="compareByIdField"
        [showClear]="showClear"
        [emptyText]="'resource-dropdown.utils.empty-message' | translate"
        [ngClass]="{'ng-invalid': invalid && !disabled, 'ng-valid': !invalid, 'ng-dirty': dirty }"
        (queryChange)="onQueryChange($event)"
        (opened)="onQueryChange('')"
        (selected)="onSelect()"
        (cleared)="onClear()"
        (blurred)="onBlur()"
      >
        <ng-template bsItem let-item>
          <span data-testid="resource-item">{{ getOptionLabel(item) }}</span>
        </ng-template>

        <ng-template bsFooter>
          <ng-content></ng-content>
        </ng-template>
      </bs-autocomplete>
      @if (placeholder) {
        <label for="autocomplete">{{ placeholder }}</label>
      }
    </p-floatLabel>
  </div>
} @else {
  <p>No resource service was provided</p>
}



